// Imports
import React, { useRef, useState } from "react"
import { useSectionDemoStepsData } from "@queries"
import { Collapse, CollapseContent } from "@molecules"
import { MobileCarousel } from "./mobile-carousel"
import { Section } from "@layout"

export const DemoSteps = () => {
  const { title, items } = useSectionDemoStepsData()

  const [activeCollapseIndex, setActiveCollapseIndex] = useState(0)
  const demoStepsContainerRef = useRef(null)

  return (
    <Section name="demo-steps">
      <div className="demo-steps__tablet">
        <h1 className="demo-steps__tablet-title"> {title} </h1>
      </div>
      <div className="demo-steps__container" ref={demoStepsContainerRef}>
        <div className="demo-steps__left">
          <CollapseContent
            data={items}
            handleTitleClick={setActiveCollapseIndex}
            selectedIndex={activeCollapseIndex}
          />
        </div>
        <div className="demo-steps__right">
          <div>
            <h1 className="demo-steps__title"> {title} </h1>
            <div className="demo-steps__right-mobile-carousel">
              <MobileCarousel
                selectedIndex={activeCollapseIndex}
                items={items}
                handleTitleClick={setActiveCollapseIndex}
              />
            </div>
            <Collapse
              data={items}
              handleTitleClick={setActiveCollapseIndex}
              selectedIndex={activeCollapseIndex}
            />
          </div>
        </div>
      </div>
    </Section>
  )
}
